export default __webpack_public_path__ + "static/media/closeIcon.ed9b42a2.svg";